__webpack_require__.p = "/Interactive-Rating-Component/";